export default "__VITE_ASSET__b55177c9__"